module.exports = __webpack_public_path__ + "static/logo_95b-feae241819d484ddb0fdb48e99d52a07.png";